<div class="bw">
  <header class="bw__header">
    <div class="bw__title-row">
      <h1 class="bw__title">Billing Wizard</h1>
      <button
        pButton
        [text]="true"
        [rounded]="true"
        icon="pi pi-question-circle"
        pTooltip="Feature Tours"
        tooltipPosition="bottom"
        styleClass="bw__tour-btn"
        (click)="tourOverlay.toggle($event)"
      ></button>
      <p-overlayPanel #tourOverlay>
        <div class="bw__tour-menu">
          <p class="bw__tour-menu-title">Available Tours</p>
          @for (opt of tourOptions; track opt.id) {
            <button class="bw__tour-option" (click)="launchTour(opt); tourOverlay.hide()">
              <i [class]="opt.icon"></i>
              <span>{{ opt.label }}</span>
            </button>
          }
        </div>
      </p-overlayPanel>
    </div>
    <p-menubar [model]="menuItems" [styleClass]="'bw__menubar'"></p-menubar>
  </header>

  <section class="bw__content">
    <router-outlet></router-outlet>
  </section>
</div>
